import { ClickAwayListener } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { AutoComplete } from '../../containers/autocomplete/AutoComplete';
import { useServiceCenter } from '../../hooks/use-service-center';
import { FilterBarInputOpt, FilterGroup } from '../../models/utilities/filter-bar';
import { SelectListItem } from '../../models/utilities/selectlist-item';
import { ApiEndpoints } from '../../utils/app-constants';
import { DatePickerWrapped } from '../datepicker-wrap/DatePickerWrap';

// #region Component Props 

interface IProps {
    filterModel : FilterGroup;
    // TODO: figure out the signature
    onModelChange : any;
    // TODO: figure out the signature
    onApplyFilter : any;
    classes? : string;
}

// #endregion

const FilterBarGroup = (props : IProps) => {

    const dispatch = useDispatch();
    const [isGroupOpen, setIsGroupOpen] = React.useState(false);
    const userServiceCenter = useServiceCenter();
    
    const onKeyDownHandler = (e: any) => {
        if (e.keyCode === 13) {
           props.onApplyFilter();
        }        
    };

    const onDropdownSelectionHandler = (name : string, e : any, value: string, type: any) => {
        console.log(e);

        const selectedIdx = e.target.selectedIndex;
        const selectedOpt = e.target.options[selectedIdx];
        const selectedUuid = selectedOpt.dataset.optid;

        props.onModelChange(name, selectedUuid, value, type);
    };

    const getDropdownSelectedValue = (model : FilterGroup) => {
        
        let currVal;
        for(let i = 0; i < model.opts.length; i++) {
            if(model.opts[i].data) {
                currVal = model.opts[i].data;
                break;
            }
        }

        return currVal ? currVal : undefined;
    };

    const buildInput = () => {

        switch (props.filterModel.type) {
            case "checkboxes": 
                const a = props.filterModel.opts.map((itm : FilterBarInputOpt) => 
                    <div className="filter-cb-option" key={`fbcb-${itm.uuid}`}>
                        <input 
                            className="form-check-input" 
                            type="checkbox" 
                            checked={ itm.data }
                            onChange={() => props.onModelChange(
                                props.filterModel.name,
                                itm.uuid,
                                !itm.data,
                                props.filterModel.type
                            )}
                            id={ `filter-input-cb-${ itm.uuid }` } />
                        <label
                            className="form-check-label"
                            htmlFor={ `filter-input-cb-${ itm.uuid }` }>
                            { itm.label }
                        </label>
                    </div>
                );
                return a;
            case "text": 
                const textEle = <div>
                            <input 
                                type="text" 
                                className="form-control"
                                placeholder={ props.filterModel.opts[0].label }
                                value={ props.filterModel.opts[0].data } 
                                onKeyDown={ onKeyDownHandler }
                                onChange={(e) => props.onModelChange(
                                    props.filterModel.name, 
                                    props.filterModel.opts[0].uuid, 
                                    e.target.value,
                                    props.filterModel.type
                                )}
                            />
                        </div>;
                return textEle;
            case "numeric": 
                const numberEle = <div>
                            <input 
                                type="number" 
                                className="form-control"
                                placeholder={ props.filterModel.opts[0].label }
                                value={ props.filterModel.opts[0].data } 
                                onKeyDown={ onKeyDownHandler }
                                onChange={(e) => props.onModelChange(
                                    props.filterModel.name, 
                                    props.filterModel.opts[0].uuid, 
                                    e.target.value,
                                    props.filterModel.type
                                )}
                            />
                        </div>;
                return numberEle;                
            case "dealer":
                return <AutoComplete
                            id={`search-input-${ props.filterModel.uuid }`}
                            dispatch={ dispatch }
                            disabled={false}
                            onSelectedCallback={(e: any) => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                (e ? e.id : ''),
                                props.filterModel.type
                            )}
                            currentValue={ props.filterModel.opts[0].data }
                            placeholder={ props.filterModel.name }
                            endpoint={ ApiEndpoints.DEALERS_AUTOCOMPLETE }
                        />;
            case "date": 
                return <DatePickerWrapped
                            dateValue={ props.filterModel.opts[0].data }
                            placeholder={ props.filterModel.name }
                            classes="form-control"
                            handleChange={(e: any) => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                e,
                                props.filterModel.type
                            )} 
                        />;
            case "dateplus": 
                return <DatePickerWrapped
                            dateValue={ props.filterModel.opts[0].data.selectedDate.qsValue }
                            isLessThanChecked={ props.filterModel.opts[0].data.checkboxValue.qsValue }
                            placeholder={ props.filterModel.name }
                            showLessThan={ true }
                            classes="form-control"
                            onLessThanChecked={(e: any) => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                e,
                                props.filterModel.type
                            )} 
                            handleChange={(e: any) => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                e,
                                props.filterModel.type
                            )} 
                        />;
            case "autocomplete":
                return <AutoComplete
                            id={`search-input-${ props.filterModel.uuid }`}
                            dispatch={ dispatch }
                            disabled={false}
                            onSelectedCallback={(e: any) => props.onModelChange(
                                props.filterModel.name,
                                props.filterModel.opts[0].uuid,
                                e,
                                props.filterModel.type
                            )}
                            suggestionRender={ props.filterModel.autoCompleteRender }
                            currentValue={ props.filterModel.opts[0].data }
                            placeholder={ props.filterModel.name }
                            endpoint={ props.filterModel.autoCompleteEndpoint.formattify(userServiceCenter.name) } 
                        />;
            case "readonly": 
                return <div>
                        <input 
                            type="number" 
                            className="form-control readonly-filter"
                            readOnly={true}
                            placeholder={ props.filterModel.opts[0].label }
                            value={ props.filterModel.opts[0].data } 
                            onKeyDown={ onKeyDownHandler }
                            onChange={(e) => props.onModelChange(
                                props.filterModel.name, 
                                props.filterModel.opts[0].uuid, 
                                e.target.value,
                                props.filterModel.type
                            )}
                        />
                    </div>;
            case "dropdown": 
                return <div>
                        <select
                            name={ name }
                            className="form-control"
                            value={ getDropdownSelectedValue(props.filterModel) } 
                            onChange={(e) => onDropdownSelectionHandler(
                                props.filterModel.name, 
                                e, 
                                e.target.value,
                                props.filterModel.type
                            )}>
                            <option id={undefined}>Choose...</option>
                            {
                                props.filterModel.opts.map((itm: FilterBarInputOpt) => (
                                    <option data-optid={itm.uuid}  key={itm.uuid} value={itm.qsValue}>{itm.label}</option>
                                ))
                            }
                        </select>
                    </div>;
            default:
                return null;
        }
    };    

    const onClickAway = () => {
        setIsGroupOpen(false);
    };

    const onToggleGroup = () => {
        setIsGroupOpen(!isGroupOpen);
    };

    return <div className="col-auto">
            {
                props.filterModel.opts.length > 1
                    ? <ClickAwayListener key="searchclickaway" onClickAway={ onClickAway }>
                            <div className="filter-group" role="group">
                                <button
                                    id={`filter-dd-${ props.filterModel.name }`}
                                    type="button"
                                    className="btn-icon filter-dropdown-toggle"
                                    onClick={ onToggleGroup }>
                                    { props.filterModel.getGroupLabel() }
                                    <i className="la la-angle-down" />
                                </button>
                                {
                                    isGroupOpen
                                        ? <div className="dropdown-menu filter-group-dropdown show">
                                            { buildInput() }
                                        </div>
                                        : null
                                }
                            </div>
                    </ClickAwayListener>
                    : <div className="filter-group">
                        { buildInput() }
                    </div>
            }
        </div>;
};

FilterBarGroup.defaultProps = {
    classes: ''
};

export { FilterBarGroup };
